<template>
  <div id="cart-view"
       v-loading="loading"
       element-loading-text="拼命加载中">
    <div class="cart-view-wrap">
      <div class="container">
        <el-radio-group class="switch-type"
                        v-model="goodsType"
                        @change="getShoppingCartList">
          <el-radio-button :label="2"><i class="fa fa-goukedan"></i>直播课</el-radio-button>
          <el-radio-button :label="5"><i class="fa fa-goukedan"></i>面授课</el-radio-button>
        </el-radio-group>
      </div>
      <div class="container"
           v-if="totalList.length">
        <div id="cart-view-card-container"
             class="live-card-table">
          <slot v-for="(item, index) in totalList">
            <ShoppingItem
                          :key="index"
                          :isLianBao="false"
                          :checked="selectedIds[item.goods_id]"
                          :item="item"
                          :index="index" />
            <!-- <ShoppingUnion v-else
                           :key="index"
                           :index="index"
                           :selectGoodsIds="item.unionSelectLength"
                           :selectedIds="selectedIds"
                           :unionItem="item" /> -->
            <!-- <slot>
              推荐联报：<slot>多学科联报 ></slot> <slot>多学科联报 ></slot>
            </slot> -->
          </slot>
        </div>
      </div>
      <div v-if="!totalList.length && !loading && !invalidCourses.length"
           class="container text-center empty-state">
        <p>
          <img src="@/assets/img/orders/cart-empty.png"
               alt="购课单还是空的，快去选课吧!"
               width="186"
               height="186">
        </p>
        <p style="color:rgba(44,45,46,0.6);">购课单还是空的，快去选课吧!</p>
        <div>
          <a class="btn btn-success btn-md"
             href="/">去选课</a>
        </div>
      </div>
      <div class="container"
           v-if="invalidCourses.length">
        <div class="row invalid-course-action">
          <div class="col-xs-6">失效课程（只显示最近失效的5个课程）</div>
          <div class="col-xs-6 text-right">
            <button @click="clearInvalidCourses"
                    class="btn btn-default">清空失效课程</button>
          </div>
        </div>
        <div id="invalid-cart-view-card-container"
             class="live-card-table">
          <ShoppingItem v-for="(item, index) in invalidCourses"
                        :key="index"
                        :item="item" />
        </div>
      </div>
      <div v-if="totalList.length"
           class="total-bottom fixed-bar jiesuan">
        <div class="container">
          <el-row>
            <el-col :xs="8"
                    :sm="8"
                    :md="8"
                    :lg="8"
                    :xl="8">
              <div class="zhixin-checkbox-wrapper">
                <input type="checkbox"
                       id="checkbox-select-all"
                       name="goods_id"
                       :checked="allChecked"
                       @click="selectAll" />
                <label for="checkbox-select-all"
                       class="label-select-all">全选</label>
                <div class="check"></div>
                <div class="fa-zhixin fa-check"></div>
              </div>
            </el-col>
            <el-col :xs="16"
                    :sm="16"
                    :md="16"
                    :lg="16"
                    :xl="16"
                    class="text-right">
              <span class="total-cost active-price">
                <slot v-if="priceInfo.totalPrice === priceInfo.needPrice">
                  ￥ <span style="font-size: 26px;">{{ Number((priceInfo.needPrice/100).toFixed(2)) }}</span>
                </slot>
                <slot v-else>
                  <span class="badge union-tag union-tag-right">已减{{ Number((priceInfo.totalPrice - priceInfo.needPrice)/100).toFixed(2) }}元</span>
                  ￥ <span style="font-size: 26px;">{{ Number((priceInfo.needPrice/100).toFixed(2)) }}</span>
                </slot>
              </span>
              <button @click="goConfirm"
                      class="btn btn-success quzhifu"
                      :disabled="!settlement">去结算(<span>{{ settlement }}</span>)
              </button>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- <Lianbao v-if="showLianbao"
               :goods-id-props="goodsIds[0]"
               mode-type="cart"
               :courses-in-cart-props="goodsIds"
               :closeCB="closeLianBaoModal"
               @lianbao-jiesuan="lianbaoJiesuan"></Lianbao> -->
    </div>
    <PlayBackList ref="playback"
                  :classList="playBackList"></PlayBackList>
  </div>
</template>

<script>
import moment from 'moment'
import $ from 'jquery'
import api from '@/api'
import * as _ from 'underscore'
import Confirm from '@/components/Confirm/index'
// import Lianbao from '@/components/LianBaoModal'
import ShoppingItem from '@/components/ShoppingItem'
// import ShoppingUnion from '@/components/ShoppingUnion'
import { mapActions, mapState } from 'vuex'
import PlayBackList from '@/components/PlayBackList'
import Vue from 'vue'
import fliter from '@/utils/filters'

Vue.use(Confirm)

export default {
  name: 'ShoppingCart',
  data () {
    return {
      goodsUnion: [],
      goodsInfo: [],
      materialInfo: [],
      invalidCourses: [],
      totalList: [],
      priceInfo: {
        totalPrice: 0,
        real_price: 0,
        cartCount: 0
      },
      selectedIds: {},
      settlement: 0,
      goodsType: 2,
      loading: true,
      showLianbao: false,
      goodsIds: [],
      unionItem: {},
      buyOfflineSubclass: [],
      // 面授课回放
      playBackList: [],
      toConfirmParams: {
        info: '',
        list: '',
        string: ''
      }
    }
  },
  components: {
    // Lianbao,
    ShoppingItem,
    // ShoppingUnion,
    PlayBackList
  },
  mounted () {
    $('#footer').hide()
    $('.el-main').css('background', 'white')
    $('html,body').animate({ scrollTop: 0 }, 100)
    this.init()
  },
  methods: {
    ...mapActions(['getCartCount']),
    init () {
      this.getShoppingCartList()
    },
    goConfirm () {
      const classList = []
      _.each(this.totalList, item => {
        if (!item.union_id) {
          if (this.selectedIds[item.goods_id]) {
            classList.push(Object.assign({}, item, { extra: { activity_type: 0, activity_id: 0 } }))
          }
        } else {
          let flag = false
          const tempItem = Object.assign({}, item, { union_cart_list: [] })
          _.each(item.union_cart_list, cla => {
            if (this.selectedIds[cla.goods_id]) {
              flag = true
              tempItem.union_cart_list.push(Object.assign({}, cla, {
                isUnion: true,
                extra: { activity_type: 2, activity_id: item.union_id }
              }))
            }
          })
          if (flag && tempItem.union_cart_list.length) {
            if (tempItem.union_cart_list.length === item.class_list.length) {
              classList.push(tempItem)
            } else {
              _.each(tempItem.union_cart_list, cla => {
                classList.push(Object.assign({}, cla, {
                  isUnion: false,
                  union_id: 0,
                  extra: { activity_type: 0, activity_id: 0 }
                }))
              })
            }
          }
        }
      })
      this.toConfirmParams = {
        info: this.priceInfo,
        list: classList,
        string: 'cart-view'
      }
      const carClassList = []
      classList.map(item => {
        if (item.classId) {
          carClassList.push(item.classId)
        }
      })
      // console.log('subclass', carClassList)
      if (this.goodsType === 5 && carClassList.length > 0) {
        this.getMyAllCourse((carClassList.join(',')))
      } else {
        this.handlePlayBack()
      }
      // this.$confirmOrder(this.priceInfo, classList, 'cart-view')
      this.zhuGeEventTrack(this.zhugeEvents.CLICK_ENROLLMENT_BUTTON, [
        '购课单',
        '去结算'
      ])
    },
    // 面授课购买小课看回放
    getMyAllCourse (list) {
      api
        .getMyAllCourseNew({ class_id: list, goods_type: 5 })
        .then(r => {
          if (r.data.code === 1) {
            const item = r.data.data || []
            for (let i = 0; i < item.length; i++) {
              this.buyOfflineSubclass[i] = item[i].subclass_id
            }
            this.handlePlayBack()
          }
        })
        .catch(e => {
          console.log('e: ', e)
        })
    },
    // 处理回放弹框
    handlePlayBack () {
      const list = this.toConfirmParams.list
      if (this.goodsType === 2) {
        this.jumpConfirmPage('')
        // this.$confirmOrder(info, list, string)
        return
      }
      // const classList = []
      // this.goodsInfo.map(item => {
      //   classList.push(item.class_id)
      // })
      // this.getMyAllCourse((classList.join(',')))
      const nowTime = parseInt(new Date().getTime() / 1000)
      let isHaveMixed = false
      let total = 0 // 总条数
      let playBackNum = 0 // 回放总条数
      var joinAllPlayBack = [] // 存放全回放goods_id
      this.playBackList = list.map((obj) => {
        let realPrice = 0
        let originalPrice = 0
        let hasNoPayPlayBack = 0
        let hasNoPayClass = 0
        let isAllPlayBack = false
        if (!obj.chapters) {
          return
        }
        obj.chapters.forEach((item) => {
          const judge = this.buyOfflineSubclass.indexOf(item.subclass_id) === -1
          if (judge && nowTime >= item.begin_at) {
            realPrice += Number(item.price) / 100
            originalPrice += Number(item.original_price) / 100
            hasNoPayPlayBack += 1
          } else if (judge && nowTime <= item.begin_at) {
            hasNoPayClass += 1
          }
        })
        if (obj.chapters && hasNoPayClass === 0) {
          isAllPlayBack = true
        }
        const isBuyPlayback = (hasNoPayPlayBack > 0 && hasNoPayClass > 0)
        const isBuyNoStartClass = (hasNoPayPlayBack === 0 && hasNoPayClass > 0)
        isHaveMixed = isHaveMixed || isBuyPlayback
        return {
          title: obj.title,
          teacher_list: obj.teachers,
          real_price: realPrice,
          original_price: originalPrice,
          id: obj.classId,
          is_buyPlayback: isBuyPlayback,
          goods_id: obj.goods_id,
          isAllPlayBack: isAllPlayBack,
          isBuyNoStartClass: isBuyNoStartClass
        }
      })
      this.playBackList.forEach(item => {
        if (item && item.isAllPlayBack) {
          playBackNum += 1
          total += 1
          joinAllPlayBack.push(item.goods_id)
        } else if (item) {
          total += 1
        }
      })
      if (isHaveMixed) {
        this.$refs.playback.show = true
        this.$refs.playback.allPlayBackClass = joinAllPlayBack
        this.$refs.playback.getReplayDiscount()
        return false
      } else if (total === playBackNum) {
        this.jumpConfirmPage(joinAllPlayBack.join(','))
        return false
      } else if (joinAllPlayBack.length > 0) {
        this.jumpConfirmPage(joinAllPlayBack.join(','))
        return false
      }
      // this.$confirmOrder(info, list, string)
      this.jumpConfirmPage('')
    },
    jumpConfirmPage (playBackList) {
      const info = this.toConfirmParams.info
      const list = this.toConfirmParams.list
      const string = this.toConfirmParams.string
      if (playBackList) {
        this.$confirmOrder(info, list, string, playBackList)
      } else {
        this.$confirmOrder(info, list, string)
      }
    },
    showLianBaoDialog (unionItem) {
      const goodsIds = []
      this.unionItem = unionItem
      _.each(unionItem.union_cart_list, item => {
        goodsIds.push(item.goods_id)
      })
      this.goodsIds = goodsIds
      this.showLianbao = true
    },
    closeLianBaoModal () {
      this.showLianbao = false
    },
    lianbaoJiesuan (unionItem) {
      const data = unionItem.info
      const tempList = []
      _.each(unionItem.info[0].union_cart_list, info => {
        tempList.push((Object.assign({}, this.setCourseDataOfLive(info), {
          extra: { activity_type: 2, activity_id: info.union_id }
        })))
      })
      data[0].union_cart_list = tempList
      data[0].can_check = unionItem.can_check
      data[0].unionSelectLength = tempList.length
      this.$confirmOrder(unionItem.priceInfo, data, 'cart-view')
    },
    selectAll (e) {
      const isSelectedAll = $(e.currentTarget).prop('checked')
      _.each(this.totalList, (item, index) => {
        this.selectedIds[item.goods_id] = isSelectedAll ? this.checkSelect(item) : isSelectedAll
        // if (!item.union_id) {
        //   this.selectedIds[item.goods_id] = isSelectedAll ? this.checkSelect(item) : isSelectedAll
        // } else {
        //   _.each(item.union_cart_list, cla => {
        //     if (this.checkSelect(cla) && !this.selectedIds[cla.goods_id]) {
        //       this.totalList[index].unionSelectLength += 1
        //     }
        //     if (!isSelectedAll && this.selectedIds[cla.goods_id]) {
        //       this.totalList[index].unionSelectLength -= 1
        //     }
        //     this.selectedIds[cla.goods_id] = isSelectedAll ? this.checkSelect(cla) : isSelectedAll
        //   })
        // }
      })
      this.handleBottomBar()
      this.updateStoredSelectStates()
      if (isSelectedAll && this.settlement !== this.goodsInfo.length - this.invalidCourses.length) {
        e.preventDefault()
      }
    },
    selectChange (data, checked, isLianBao, index) {
      if (isLianBao) {
        _.each(data, (cla) => {
          if (this.checkSelect(cla) && !this.selectedIds[cla.goods_id]) {
            this.totalList[index].unionSelectLength += 1
          }
          if (!checked && this.selectedIds[cla.goods_id]) {
            this.totalList[index].unionSelectLength -= 1
          }
        })
      }
      _.each(data, (item) => {
        this.selectedIds[item.goods_id] = checked ? this.checkSelect(item) : checked
      })
      this.handleBottomBar()
      this.updateStoredSelectStates()
    },
    clearInvalidCourses: function () {
      const goodsId = _.map(this.invalidCourses, item => item.goods_id)
      this.clearInvalid(goodsId)
    },
    deleteItem (goodsIds) {
      this.$showDialog('确定要删除课程吗？', () => {
        this.clearInvalid(goodsIds)
      })
    },
    clearInvalid (goodsIds) {
      api.delCart({ goods_ids: JSON.stringify(goodsIds) }).then(res => {
        if (res.data.code === 1) {
          this.init()
          this.getCartCount()
        }
      })
    },
    getTotalPrice () {
      const goodsIds = this.getSelectedIds()
      if (this.goodsType === 2) {
        goodsIds.forEach(item => {
          item.offline_replay = 0
        })
      } else if (this.goodsType === 5) {
        goodsIds.forEach(item => {
          item.offline_replay = 1
        })
      }
      if (goodsIds.length) {
        api.calCartPrice({ compute: true, goods_items: goodsIds }).then(res => {
          if (res.data.code === 1) {
            this.priceInfo = {
              totalPrice: res.data.data.original_price,
              needPrice: res.data.data.cart_price,
              unionMap: res.data.data.union_map
            }
          }
        })
      }
    },
    getShoppingCartList () {
      this.totalList = []
      this.invalidCourses = []
      this.loading = true
      api.getShoppingCart({
        goods_type: this.goodsType,
        course_belong: '质心灵动量'
      }).then(res => {
        if (res.data.code === 1 && res.data.data) {
          this.processGoodsUnion(res.data.data.goods_union || [])
          this.processMaterialInfo(res.data.data.material_info || [])
          this.processCourses(this.sortByTime(res.data.data.goods_info || []))
        } else if (res.data.code === 1 && !res.data.data) {
          this.zhuGeEventTrack(this.zhugeEvents.VISIT_COURSE_PURCHASING_LIST, [
            this.goodsType === 2 ? '直播课' : '面授课',
            0
          ])
        }
        this.loading = false
      }, _ => {
        this.loading = false
      })
    },
    getSelectedIds () {
      const arr = []
      _.each(this.selectedIds, (val, key) => {
        if (val) {
          arr.push({ goods_id: key, goods_type: this.goodsType })
        }
      })
      return arr
    },
    processCourses (goodsInfo) {
      // console.log('goodsInfo', goodsInfo)
      const courses = []
      this.goodsInfo = goodsInfo
      const invalidCourses = []
      goodsInfo.forEach((model) => {
        this.setMaterials(model)
        if (!model.is_invalid) {
          courses.push(model)
        } else {
          invalidCourses.push(Object.assign({}, this.setCourseDataOfLive(model), { is_invalid: true }))
        }
      })
      this.invalidCourses = invalidCourses.sort((a, b) => {
        return a.update_cart_at - b.update_cart_at > 0 ? -1 : 1
      })
      // console.log(courses)
      this.processUnionGroup(courses)
    },
    processUnionGroup (data) {
      const processedData = []
      _.each(data, item => {
        processedData.push(this.setCourseDataOfLive(item))
      })
      // const dataGroup = _.groupBy(processedData, 'union_id')
      // debugger
      // const dataGroup = _.groupBy(processedData, 'classId')
      const goodsInfo = processedData
      // for (const key in dataGroup) {
      //   if (Object.prototype.hasOwnProperty.call(dataGroup, key)) {
      //     if (key !== '0') {
      //       goodsInfo.push(this.assignUnionGroup(dataGroup[key], key))
      //     }
      //   }
      // }
      this.initChecked(goodsInfo)
      this.totalList = this.sortByTime(goodsInfo)
      this.zhuGeEventTrack(this.zhugeEvents.VISIT_COURSE_PURCHASING_LIST, [
        this.goodsType === 2 ? '直播课' : '面授课',
        Number(this.totalList.length)
      ])
    },
    setCourseDataOfLive (info) {
      const duration = this.getClassDutation({
        begin_at: info.begin_at,
        time_cycle: info.time_cycle,
        end_at: info.end_at
      })
      const needPrice = info.left_sub_price || info.price
      const materialGoodsPrice = fliter.handleCountPrice(info.material_goods_price / 100)
      const unionsInfo = info.unions_info
      return {
        classId: info.class_id,
        subject: info.subject || info.title,
        teachers: info.teachers,
        subclasses: info.chapters, // 确认订单页面需要
        left_sub_count: info.left_sub_count,
        left_sub_price: info.left_sub_price,
        price: info.price,
        deletedPrice: info.price || info.virtual_price,
        needPurchasedSub: info.chapters.length, // 确认订单页面需要
        duration: duration,
        needPrice,
        groupsPrice: info.groupsPrice,
        group_set: info.group_set,
        need_address: info.need_address,
        can_refund: info.can_refund,
        in_cart_at: info.in_cart_at,
        union_id: info.union_id,
        goods_id: info.goods_id,
        goods_type: info.goods_type,
        materialsCount: info.materialsCount,
        materials: info.materials,
        chapters: info.chapters,
        ordered: info.ordered,
        quota: info.quota,
        update_cart_at: info.update_cart_at,
        cover: info.cover || process.env.VUE_APP_IMAGE_DEFAULT_ORIGIN + '/img/live/default-cover.png',
        title: info.title,
        material_goods_id: info.material_goods_id,
        material_goods_price: materialGoodsPrice,
        unionsInfo
      }
    },
    assignUnionGroup (group, key) {
      const tmp = JSON.parse(JSON.stringify(this.goodsUnion[key]))
      tmp.materialsCount = 0
      _.each(tmp.materials_info, (item) => {
        tmp.materialsCount = tmp.materialsCount + item.num
      })
      tmp.in_cart_at = group[0].in_cart_at
      _.each(tmp.class_list, (cls, index) => {
        _.each(group, item => {
          if (cls.class_id === item.classId) {
            item.groupSort = index
          }
        })
      })
      tmp.union_cart_list = group.sort((a, b) => {
        return a.groupSort - b.groupSort < 0 ? -1 : 1
      })
      tmp.can_check = !(tmp.union_cart_list.length !== tmp.class_list.length || Date.now() < tmp.begin_at * 1000)
      return tmp
    },
    setMaterials (model) {
      model.materialsCount = 0
      model.materials = _.map(model.material, (item) => {
        const id = Object.keys(item)[0]
        model.materialsCount = model.materialsCount + item[id]
        return this.materialInfo[id] ? this.materialInfo[id] + ' *' + item[id] : ''
      }) || []
    },
    processGoodsUnion (dataList) {
      const goodsUnion = {}
      dataList.forEach(item => {
        goodsUnion[item.union_id] = item
      })
      this.goodsUnion = goodsUnion
    },
    sortByTime (data) {
      return data.sort(function (a, b) {
        const a1 = a.in_cart_at
        const a2 = b.in_cart_at
        return a1 - a2 > 0 ? -1 : 1
      })
    },
    processMaterialInfo (dataList) {
      const materialInfo = {}
      dataList.forEach(item => {
        materialInfo[item.id] = item.name
      })
      this.materialInfo = materialInfo
    },
    initChecked (totalList) {
      this.selectedIds = {}
      const storedSelectStates = this.getStoredSelectStates()
      // debugger
      totalList.forEach(item => {
        // if (!item.union_id) {
        //   const goodsId = item.goods_id
        //   this.selectedIds[goodsId] = this.checkSelect(item) && storedSelectStates[goodsId] !== false
        // } else {
        //   item.unionSelectLength = 0
        //   _.each(item.union_cart_list, i => {
        //     const isSelected = this.checkSelect(i) && storedSelectStates[i.goods_id] !== false
        //     this.selectedIds[i.goods_id] = isSelected
        //     if (isSelected) {
        //       item.unionSelectLength += 1
        //     }
        //   })
        // }
        const goodsId = item.goods_id
        this.selectedIds[goodsId] = this.checkSelect(item) && storedSelectStates[goodsId] !== false
      })
      this.handleBottomBar()
    },
    checkSelect (item) {
      item.tips = ''
      if (item.goods_type !== 2) {
        if (item.ordered >= item.quota) {
          // item.tips = '课程已满员，无法购买。'
          return true
        }
        // const now = $.now()
        // const endAt = item.chapters[item.chapters.length - 1].begin_at - 30 * 60
        // if (endAt * 1000 < now) {
        //   item.tips = '课程已结束，无法购买。'
        //   return false
        // }
        return true
      }
      return true
    },
    handleBottomBar () {
      this.settlement = this.getSelectedIds().length
      if (this.settlement) {
        this.getTotalPrice()
      } else {
        this.priceInfo.totalPrice = 0
        this.priceInfo.needPrice = 0
      }
    },
    updateStoredSelectStates () {
      window.localStorage.setItem('cart-select-states', JSON.stringify(this.selectedIds))
    },
    getStoredSelectStates () {
      return JSON.parse(window.localStorage.getItem('cart-select-states') || '{}')
    },
    getClassDutation (info = {
      begin_at: 0,
      end_at: 0,
      time_cycle: null
    }) {
      const now = moment()
      const beginAt = moment(info.begin_at * 1000)
      const endAt = moment(info.end_at * 1000)
      let time = ''
      let date = ''
      if (info.time_cycle) {
        const timeCycle = JSON.parse(info.time_cycle)
        time = `${timeCycle[0].begin_at}-${timeCycle[timeCycle.length - 1].end_at}`
      }
      if (beginAt.year() !== now.year() || beginAt.year() !== endAt.year()) {
        date = `${beginAt.format('YYYY.MM.DD')} - ${endAt.format('YYYY.MM.DD')}`
      } else {
        date = `${beginAt.format('MM月DD日')} - ${endAt.format('MM月DD日')}`
      }
      return {
        date,
        time
      }
    }
  },
  computed: {
    ...mapState({
      shoppingSum: state => state.shopping.shoppingSum
    }),
    allChecked () {
      return this.goodsInfo.length - this.invalidCourses.length === this.settlement
    }
  },
  beforeDestroy () {
    $('#footer').show()
    $('.el-main').css('background', '')
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/_base.scss";
@import "@/assets/scss/mixins/base.scss";
@import "@/assets/scss/partials/_zhixin.scss";
@import "@/assets/scss/partials/_order.scss";

#cart-view {
  padding-top: 0;
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;

  .label-select-all {
    line-height: 36px;
  }

  .union-title {
    margin-left: 8px;
  }

  .ziliao .fa-zeng {
    vertical-align: initial;
  }

  .switch-type {
    margin-top: 20px;
    margin-bottom: 24px;

    .el-radio-button__inner {
      padding: 12px 30px;
      font-size: 18px;
      font-weight: 400;
      line-height: 18px;
    }

    i {
      font-size: 18px;
      margin-right: 5px;
    }
  }

  @media (max-width: 767px) {
    .cart-price-box > div.text-center {
      text-align: right;
    }
  }
}
</style>
